export default "__VITE_ASSET__22159a80__"